import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [openModal]);
  return <>
      <footer className="bg-[#422006] text-[#FFF8F0]/60 py-10 text-center text-sm" data-id="element-24">
        <div className="max-w-4xl mx-auto px-4 flex flex-col items-center gap-6" data-id="element-25">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-[#FFF8F0]/80 font-medium" data-id="element-26">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-white transition-colors underline decoration-transparent hover:decoration-white underline-offset-4" data-id="element-27">
              Política de Privacidad
            </button>
            <button onClick={() => setOpenModal('terms')} className="hover:text-white transition-colors underline decoration-transparent hover:decoration-white underline-offset-4" data-id="element-28">
              Términos y Condiciones
            </button>
          </div>
          <p className="opacity-70" data-id="element-29">
            © {new Date().getFullYear()} Menús Express. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-30">
        {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-31">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closeModal} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-32" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" data-id="element-33">
              <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gray-50/50" data-id="element-34">
                <h3 className="text-2xl font-bold text-[#422006]" data-id="element-35">
                  {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={closeModal} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-full transition-colors" aria-label="Cerrar" data-id="element-36">
                  <X size={24} data-id="element-37" />
                </button>
              </div>

              <div className="p-6 md:p-8 overflow-y-auto text-[#78350F] space-y-6 text-left" data-id="element-38">
                {openModal === 'privacy' ? <>
                    <section data-id="element-39">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-40">
                        1. Recopilación de Información
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-41">
                        Recopilamos información cuando te registras en nuestro
                        sitio, realizas una compra o te suscribes a nuestro
                        boletín. La información recopilada incluye tu nombre y
                        dirección de correo electrónico.
                      </p>
                    </section>
                    <section data-id="element-42">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-43">
                        2. Uso de la Información
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-44">
                        Cualquier información que recopilemos de ti puede ser
                        utilizada para personalizar tu experiencia, mejorar
                        nuestro sitio web, mejorar el servicio al cliente y
                        procesar transacciones de manera eficiente.
                      </p>
                    </section>
                    <section data-id="element-45">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-46">
                        3. Protección de Datos
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-47">
                        Implementamos una variedad de medidas de seguridad para
                        mantener la seguridad de tu información personal.
                        Utilizamos encriptación avanzada para proteger la
                        información confidencial transmitida en línea.
                      </p>
                    </section>
                    <section data-id="element-48">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-49">
                        4. Uso de Cookies
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-50">
                        Nuestras cookies mejoran el acceso a nuestro sitio e
                        identifican a los visitantes frecuentes. Sin embargo,
                        este uso de cookies no está vinculado de ninguna manera
                        a ninguna información de identificación personal en
                        nuestro sitio.
                      </p>
                    </section>
                    <section data-id="element-51">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-52">
                        5. Consentimiento
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-53">
                        Al utilizar nuestro sitio, aceptas nuestra política de
                        privacidad en línea.
                      </p>
                    </section>
                  </> : <>
                    <section data-id="element-54">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-55">
                        1. Aceptación de los Términos
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-56">
                        Al acceder y utilizar este sitio web, aceptas estar
                        sujeto a estos términos y condiciones de uso, todas las
                        leyes y regulaciones aplicables, y aceptas que eres
                        responsable del cumplimiento de las leyes locales
                        aplicables.
                      </p>
                    </section>
                    <section data-id="element-57">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-58">
                        2. Licencia de Uso
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-59">
                        Se concede permiso para descargar temporalmente una
                        copia de los materiales (información o software) en el
                        sitio web para visualización transitoria personal y no
                        comercial. Esta es la concesión de una licencia, no una
                        transferencia de título.
                      </p>
                    </section>
                    <section data-id="element-60">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-61">
                        3. Propiedad Intelectual
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-62">
                        Todo el contenido incluido en este sitio, como texto,
                        gráficos, logotipos, imágenes y software, es propiedad
                        exclusiva o está licenciado para nuestro uso y está
                        protegido por las leyes de propiedad intelectual
                        internacionales.
                      </p>
                    </section>
                    <section data-id="element-63">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-64">
                        4. Limitación de Responsabilidad
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-65">
                        En ningún caso seremos responsables de ningún daño
                        (incluyendo, sin limitación, daños por pérdida de datos
                        o beneficios, o debido a la interrupción del negocio)
                        que surja del uso o la incapacidad de usar los
                        materiales en el sitio web.
                      </p>
                    </section>
                    <section data-id="element-66">
                      <h4 className="font-bold text-lg mb-2 text-[#422006]" data-id="element-67">
                        5. Modificaciones
                      </h4>
                      <p className="leading-relaxed opacity-90" data-id="element-68">
                        Podemos revisar estos términos de servicio para nuestro
                        sitio web en cualquier momento sin previo aviso. Al usar
                        este sitio web, aceptas estar sujeto a la versión actual
                        de estos términos y condiciones de uso.
                      </p>
                    </section>
                  </>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}